import { useEffect } from 'react';
import { useHistory } from 'react-router';

function InvoiceNFPage() {
  const history = useHistory();

  useEffect(() => {
    history.push(`/app/fiscal/invoice`);
  }, []);

  return null;
}

export default InvoiceNFPage;
